// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"9e0d5ee8","133":"dec0d48b","480":"7b2e14bb","804":"31edb5ee"}[chunkId] + ".chunk.css";
};